/* NSC size guide dialog (ported from v2 nsc-pdp.js, size-guide part only). Does not touch theme.js. */
(function () {
  const init = () => {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;
    const dlg = document.querySelector('[data-nsc-size-guide]');
    const openers = section.querySelectorAll('[data-nsc-size-open]');
    if (!dlg || !openers.length || dlg.dataset.ready) return;
    dlg.dataset.ready = '1';
    const body = dlg.querySelector('[data-nsc-size-body]');
    const KEY = { 'breite': 'Width', 'width': 'Width', 'länge': 'Length', 'laenge': 'Length', 'length': 'Length', 'brust': 'Chest', 'brustumfang': 'Chest', 'chest': 'Chest', 'ärmel': 'Sleeve', 'aermel': 'Sleeve', 'sleeve': 'Sleeve', 'ärmellänge': 'Sleeve length', 'sleeve length': 'Sleeve length', 'schulter': 'Shoulder', 'shoulder': 'Shoulder', 'taille': 'Waist', 'waist': 'Waist', 'hüfte': 'Hip', 'hip': 'Hip', 'größe': 'Size', 'groesse': 'Size', 'size': 'Size' };
    const label = (t) => { const k = (t || '').trim().toLowerCase(); if (/^toleranz|^tolerance/.test(k)) return 'Size'; return KEY[k] || (t || '').trim(); };
    const isMeasure = (t) => { const l = label(t); return l !== 'Size' && Object.values(KEY).includes(l); };
    const build = (rows) => {
      const table = document.createElement('table');
      const tb = document.createElement('tbody');
      rows.forEach((cells, ri) => {
        const tr = document.createElement('tr');
        cells.forEach((c, ci) => {
          const head = ri === 0 || ci === 0;
          const el = document.createElement(head ? 'th' : 'td');
          if (head) el.scope = ri === 0 ? 'col' : 'row';
          el.textContent = head ? label(c) + (ri > 0 && ci === 0 && isMeasure(c) ? ' (cm)' : '') : c;
          tr.appendChild(el);
        });
        tb.appendChild(tr);
      });
      table.appendChild(tb);
      return table;
    };
    let table = null;
    const tpl = dlg.querySelector('template[data-nsc-size-src]');
    if (tpl && tpl.dataset.nscSizeSrc === 'metafield') table = tpl.content.querySelector('table').cloneNode(true);
    if (!table) {
      const desc = Array.from(section.querySelectorAll('.product-description table')).find((t) => /breite|länge|laenge|width|length|brust|chest/i.test(t.textContent));
      if (desc) {
        const rows = Array.from(desc.querySelectorAll('tr')).map((r) => Array.from(r.querySelectorAll('th,td')).map((c) => c.textContent.trim()));
        if (rows.length > 1) table = build(rows);
      }
    }
    if (!table && tpl && tpl.dataset.nscSizeSrc === 'setting') table = tpl.content.querySelector('table').cloneNode(true);
    if (!table) return; // nothing real to show -> link stays hidden
    body.appendChild(table);
    let last = null;
    const close = () => { if (dlg.open) dlg.close(); };
    dlg.addEventListener('close', () => { if (last) last.focus(); });
    dlg.querySelector('[data-nsc-size-close]').addEventListener('click', close);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    openers.forEach((b) => {
      b.hidden = false;
      b.addEventListener('click', () => {
        last = b;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        dlg.querySelector('[data-nsc-size-close]').focus();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();